import { load, CheerioAPI } from 'cheerio/lib/slim';

type CheerioSlimApi = CheerioAPI;

/**
 * isDocument parameter of cheerio load is set to false as to avoid body, head and other tags being added by
 * cheerio compare https://cheerio.js.org/modules.html#load
 */
function cheerioLoad(content: string): CheerioAPI {
  return load(content, { decodeEntities: true }, false);
}
// https://github.com/cheeriojs/cheerio#using-htmlparser2
export { cheerioLoad };
export type { CheerioSlimApi };
